"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0641 2.00003C12.2521 2.00183 12.4315 2.07916 12.5618 2.2146L15.5043 5.27215C15.7724 5.55071 15.7639 5.99384 15.4853 6.26192C15.2068 6.52999 14.7637 6.5215 14.4956 6.24294L12.7574 4.43685V10.8342C12.7574 11.2208 12.444 11.5342 12.0574 11.5342C11.6708 11.5342 11.3574 11.2208 11.3574 10.8342V4.38997L9.49493 6.25252C9.22157 6.52589 8.77835 6.52589 8.50498 6.25252C8.23161 5.97916 8.23161 5.53594 8.50497 5.26258L11.5625 2.20503C11.6954 2.07211 11.8762 1.99823 12.0641 2.00003Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 15.25C21 17.2935 19.3435 18.95 17.3 18.95L6.7 18.95C4.65655 18.95 3 17.2935 3 15.25L3 8.04996C3 6.39313 4.34313 5.05 5.99995 5.05V6.45C5.11632 6.45 4.4 7.16633 4.4 8.04996L4.4 15.25C4.4 16.5203 5.42975 17.55 6.7 17.55H17.3C18.5703 17.55 19.6 16.5203 19.6 15.25V8.05005C19.6 7.16637 18.8836 6.45 18 6.45C17.6134 6.45 17.3 6.1366 17.3 5.75C17.3 5.3634 17.6134 5.05 18 5.05C19.6568 5.05 21 6.39317 21 8.05005V15.25Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.04995 5.75C5.04995 5.3634 5.36335 5.05 5.74995 5.05L5.99995 5.05C6.38655 5.05 6.69995 5.3634 6.69995 5.75C6.69995 6.1366 6.38655 6.45 5.99995 6.45L5.74995 6.45C5.36335 6.45 5.04995 6.1366 5.04995 5.75Z",
  fill: "currentColor"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CardMoveUp24.js.map